import classNames from "classnames";
import { ReactNode } from "react";
import Select, { GroupBase, StylesConfig } from "react-select";
import { DropdownOption } from "../dropdown";

type MultiSelectorProps = {
  isMulti?: true;
  onChange(value?: string[] | number[]): void;
  value?: (string | number | null)[];
};
type SingleSelectorProps = {
  isMulti?: false;
  value?: string | number;
  onChange(value?: string | number): void;
};
type Props = (MultiSelectorProps | SingleSelectorProps) & {
  options: DropdownOption[];
  isClearable?: boolean;
  isSearchable?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  noOptionsMessage?(obj: { inputValue: string }): ReactNode;
  className?: string;
  menuPlacement?: "top" | "bottom" | "auto";
  styles?: StylesConfig<DropdownOption, boolean, GroupBase<DropdownOption>> | undefined;
};

const ReactSelect: React.FC<Props> = (props) => {
  const {
    options,
    isDisabled,
    value,
    className,
    onChange,
    styles,
    placeholder,
    noOptionsMessage = () => <span>گزینه ای وجود ندارد</span>,
    ...rest
  } = props;
  return (
    <Select
      styles={
        styles
          ? styles
          : {
              control: (base, props) => ({
                ...base,
                "&:hover": {
                  borderColor: "hsla(215 27.9% 16.9%, 0.2)",
                },
                boxShadow: "none",
                borderColor: "hsla(215 27.9% 16.9%, 0.2)",
                outline: "none",
                WebkitBoxShadow: props.isFocused
                  ? "rgb(255, 255, 255) 0px 0px 0px 2px, rgb(192, 192, 192) 0px 0px 0px 4px, rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px"
                  : "rgb(255, 255, 255) 0px 0px 0px 0px, rgb(192, 192, 192) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                transition: "all 150ms",
                borderRadius: 8,
                marginLeft: 4,
                marginRight: 4,
                marginBottom: 4,
              }),
              indicatorSeparator: (base) => ({
                ...base,
                display: "none",
              }),
              multiValue: (base) => ({
                ...base,
                borderRadius: 6,
                backgroundColor: "#e6f4cb",
                padding: "5px 12px 5px 5px",
              }),
              multiValueRemove: (base) => ({
                ...base,
                borderRadius: 4,
                "&:hover": {
                  backgroundColor: "#b9e561",
                  color: "black",
                },
              }),
            }
      }
      placeholder={placeholder || "انتخاب کنید..."}
      noOptionsMessage={noOptionsMessage}
      className={classNames("focus:outline-none", className)}
      onChange={(e: any) => {
        if (Array.isArray(e)) {
          const values = e.map((i) => i.value);
          // @ts-expect-error ts(2345)
          return onChange(values);
        }
        return onChange(e?.value);
      }}
      value={
        Array.isArray(value)
          ? options.filter((i) => value.includes?.(i.value))
          : options.find((i) => i.value === value) || null
      }
      options={options}
      isDisabled={isDisabled}
      {...rest}
    />
  );
};

export default ReactSelect;
